/**
 * There's 30 steps in total.
 * @returns 
 */

import { useSelector } from "react-redux"

export const ProgressLine = () => {
    const progress = useSelector((state) => state.progress.value)
    return (
        <article className="absolute inset-0 h-2 md:h-1 bg-brand-yellow z-20" style={{width: `${progress}%`}}>

        </article>
    )
}